import styled from 'styled-components';

export const ContainerTemplate = styled.div`
  padding: 0;
  background: transparent;
  min-height: 100%;
`;
